// extracted by mini-css-extract-plugin
export default {"Flash":"OverridingGlobalFundingFileWarning-module__Flash--nU7J4"};